import React from "react";
import ProfileHandlerComponent from "@components/User/Profile/ProfileHandler/ProfileHandler";

export default function ProfileHandler() {
  return <ProfileHandlerComponent />;
}
